// extracted by mini-css-extract-plugin
module.exports = {"description":"bH_oG6p9xx8A0LpBTN2wJ","tableStep":"_1RelO-8qquI6Buhfmpr7uj","dropZone":"_3-0NWib9uEeMLJwWINfb21","dropZoneContent":"_34EcRxzNxTY8gh0EusVvTJ"};